var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[_vm.content ? { 'font-weight-bold': _vm.bold } : 'title'],style:(_vm.color ? { color: _vm.color } : {})},[_vm._v(_vm._s(_vm.localValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }